import { render, staticRenderFns } from "./translation.vue?vue&type=template&id=2388d1a9&scoped=true&"
import script from "./translation.vue?vue&type=script&lang=js&"
export * from "./translation.vue?vue&type=script&lang=js&"
import style0 from "./translation.vue?vue&type=style&index=0&id=2388d1a9&scoped=true&lang=css&"
import style1 from "./translation.vue?vue&type=style&index=1&id=2388d1a9&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388d1a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2388d1a9')) {
      api.createRecord('2388d1a9', component.options)
    } else {
      api.reload('2388d1a9', component.options)
    }
    module.hot.accept("./translation.vue?vue&type=template&id=2388d1a9&scoped=true&", function () {
      api.rerender('2388d1a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/translation/translation.vue"
export default component.exports